/**
 * Controller: resourcesRequestsRemoveModal
 */
angular.module('acme.view.application.resources.requests.removeModal.controllers', [
  'ui.bootstrap'
])
.controller('ResourcesRequestsRemoveModalController', [ '$scope', '$uibModalInstance', 'resourceRequest', 'emailSetting', 'showEmailNotification', function($scope, $uibModalInstance, resourceRequest, emailSetting, showEmailNotification) {

  $scope.resourcesRequestsRemoveModal = {

    errors: [],

    notificationEmail: true,
    notificationType: 'always',
    notificationList: [],
    showEmailNotification: true,

    model: {
      name: resourceRequest.resourceTemplateName,
      label: resourceRequest.resourceTemplateName,
      eventName: resourceRequest.eventName
    },

    init: function() {
      this.notificationType = emailSetting;
      this.showEmailNotification = showEmailNotification;
      this.setNotificationList();
    },

    setNotificationList: function () {
      if (resourceRequest &&
          resourceRequest.request &&
          resourceRequest.request.resourceCategory === 'Personnel' &&
          resourceRequest.request.resourceName) {
        this.notificationList = [];
        this.notificationList.push(resourceRequest.request.resourceName);
      }
    },

    checkNotification: function() {
      if (this.notificationType === 'always') {
        this.notificationEmail = true;
      }else if (this.notificationType === 'never') {
        this.notificationEmail = false;
      }
    },

    hasErrors: function() {
      return (this.errors.length > 0);
    },

    done: function() {
      this.success();
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    success: function () {
      console.warn(this.notificationEmail);
      this.checkNotification();
      $uibModalInstance.close(this.notificationEmail);
    }
  };


  $scope.resourcesRequestsRemoveModal.init();

}]);